var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 36C28.665 36 36.5 28.165 36.5 18.5C36.5 8.83502 28.665 1 19 1C9.33502 1 1.5 8.83502 1.5 18.5C1.5 28.165 9.33502 36 19 36Z",
    stroke: "#FF4A4A",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7508 9.46082H27.8175L21.1175 17.1191L29 27.5383H22.8283L17.995 21.2183L12.4633 27.5383H9.395L16.5617 19.3466L9 9.46165H15.3283L19.6975 15.2383L24.7508 9.46082ZM23.675 25.7033H25.3742L14.405 11.2H12.5817L23.675 25.7033Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.f9d5b8de14747a4dd18384889c2999fd.svg";
export { ForwardRef as ReactComponent };